import { makeHtmlId } from '../../../component/components/comment-list/id-utils';
export const constructScrollAnchor = (htmlId) => htmlId
    ? {
        id: htmlId,
        timestamp: Date.now(),
    }
    : undefined;
export const constructScrollAnchorForComment = (commentId) => commentId
    ? {
        id: makeHtmlId(commentId),
        timestamp: Date.now(),
    }
    : undefined;
//# sourceMappingURL=comments-types.js.map